// extracted by mini-css-extract-plugin
export default {"Checkbox__text":"Checkbox_Checkbox__text__8ggu4","Checkbox__additional_info":"Checkbox_Checkbox__additional_info__ZjboR"};